<template>
  <div class="search-field-container">
    <label v-if="showLabel" :for="id" class="form-label">{{ label }}</label>
    <div v-if="showRequired" class="required-mark-container">
      <span v-if="required" class="required-mark">必須</span>
    </div>
    <div class="search-container">
      <input 
        type="text" 
        :id="id" 
        :name="id" 
        :class="inputClass" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :placeholder="placeholder"
        :disabled="disabled"
        :autocomplete="autocomplete"
      />
      <button type="button" class="search-button" @click="$emit('search')">
        <i class="fas fa-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSearchField',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  emits: ['update:modelValue', 'search']
}
</script>

<style scoped>
.search-field-container {
  display: flex;
  align-items: center;
  background-color: #FFF;
  padding: 10px 30px;
  margin: 5px;
  border-radius: 4px;
}

.form-label {
  min-width: 180px;
  font-weight: 700;
  flex: 0 0 180px;
}

.required-mark-container {
  width: 40px;
  margin-right: 10px;
  flex-shrink: 0;
}

.required-mark {
  background-color: #ff0000;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  display: inline-block;
}

.search-container {
  flex: 1;
  width: 390px; /* Fixed width as requested */
  min-width: 200px; /* Ensure minimum width for the input field */
  position: relative;
  display: flex;
  align-items: center;
}

input {
  width: 100%;
  padding: 8px;
  padding-right: 40px; /* Make space for search icon */
  border: 2px solid #195983;
  border-radius: 4px;
  box-sizing: border-box;
}

.search-button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: #195983;
  border: none;
  color: white;
  width: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  cursor: pointer;
}

.search-button:hover {
  background-color: #0d4b6f;
}
</style>
